export const smoothScroll = () => {
  window.smoothScroll = function(target) {
    var scrollContainer = target;
    do { //find scroll container
        scrollContainer = scrollContainer.parentNode;
        if (!scrollContainer) return;
        scrollContainer.scrollTop += 1;
    } while (scrollContainer.scrollTop == 0);

    var targetY = 0;
    do { //find the top of target relatively to the container
        if (target == scrollContainer) break;
        targetY += target.offsetTop;
    } while (target = target.offsetParent);

    scroll = function(c, a, b, i) {
        i++; if (i > 30) return;
        c.scrollTop = a + (b - a) / 30 * i;
        setTimeout(function(){ scroll(c, a, b, i); }, 20);
    }
    // start scrolling
    scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);
  }
};

export const lazyLoadImage = ()=>{
  if ('loading' in HTMLImageElement.prototype) {
    const images = document.querySelectorAll('img[loading="lazy"]');
    images.forEach(img => {
      img.src = img.dataset.src;
    });
  } else {
    // Dynamically import the LazySizes library
    const script = document.createElement('script');
    script.src =
      'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.1.2/lazysizes.min.js';
    document.body.appendChild(script);
  }
}

export const localstorage_add_log = (action,source,redirect)=>{
  let referer_log = {};
  referer_log.action=action;
  referer_log.source=source;
  referer_log.redirect=redirect; 
  referer_log.date= new Date();
  let local_referer_logs = JSON.parse(window.localStorage.getItem('vms_referer_logs'));
  if(local_referer_logs!=null){
    local_referer_logs.push(referer_log);
    window.localStorage.setItem('vms_referer_logs', JSON.stringify(local_referer_logs));
  }else{
    window.localStorage.setItem('vms_referer_logs', JSON.stringify([referer_log]));
  }
}